import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import { getColorFamilies } from '@/features/my-style/api/my-style'
import type { ColorFamily } from '@/types/my-style'

/** BE-144 — `GET /user/style/color-families` (cached 300 s server-side); off until a colour picker opens. */
export const useColorFamiliesQuery = (enabled: MaybeRef<boolean> = true) => {
  return createQuery<ColorFamily[]>({
    key: computed(() => (unref(enabled) ? ['color-families'] : null)),
    fetcher: getColorFamilies,
    staleTime: 10 * 60 * 1000,
  })
}
